<div class="contact-filter-panel">
    <div class="filter-header">
        <label class="body-2">{{'crm.contact_filter_title' |stringLiterals}}</label>
        <smart-icon name="close" (click)="clickClose()" class="hover-color"></smart-icon>
    </div>
    <div class="filter-area">
        <filter-panel [config]="filterConfig"></filter-panel>
        <div class="control">
            <tam-field-selector [config]="fieldConfig">
                <ng-template #customBtn>
                    <span class="add-filter-btn hover-link">{{'crm.add_filter' |stringLiterals}}</span>
                </ng-template>
            </tam-field-selector>
        </div>
    </div>
    <div class="footer">
        <button tam-button tamType="secondary" tamSize="normal" (click)="clickReset()">
            {{'crm.reset_to_default' |stringLiterals}}</button>
        <button tam-button tamType="primary" tamSize="normal" (click)="clickApply()" [tamLoading]="isProgressing">
            {{'general.apply' | stringLiterals}}</button>
    </div>
</div>